import { useState, type FormEvent } from 'react';
import { useAuth } from '../../auth/AuthProvider';
import { Button } from '../../ui/Button';
import { Field } from '../../ui/Field';
import { Input } from '../../ui/Input';
import { BarMark } from '../../shell/BarMark';

export function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (busy) return;
    setError(null);
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (!r.ok) setError(r.message ?? 'Falha ao entrar');
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg-0)',
        padding: 24
      }}
    >
      <form
        onSubmit={onSubmit}
        style={{
          width: 380,
          maxWidth: '100%',
          background: 'var(--bg-1)',
          border: '1px solid var(--border)',
          borderRadius: 'var(--r-lg)',
          padding: '32px 28px',
          boxShadow: 'var(--shadow-2)',
          animation: 'scaleIn 0.2s var(--ease)'
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            marginBottom: 22
          }}
        >
          <BarMark size={28} />
          <span
            style={{
              fontSize: 22,
              fontWeight: 800,
              letterSpacing: '-0.03em',
              color: 'var(--text-0)'
            }}
          >
            db<span style={{ color: 'var(--brand)' }}>.</span>
          </span>
        </div>

        <h1 style={{ fontSize: 18, marginBottom: 4 }}>Entrar no console</h1>
        <p style={{ fontSize: 13, color: 'var(--text-2)', marginBottom: 22 }}>
          Acesse com sua conta de administrador.
        </p>

        {error && (
          <div
            style={{
              background: 'var(--danger-bg)',
              color: 'var(--danger)',
              border:
                '1px solid color-mix(in oklch, var(--danger) 30%, transparent)',
              borderRadius: 'var(--r-sm)',
              padding: '9px 12px',
              fontSize: 13,
              marginBottom: 14
            }}
            role="alert"
          >
            {error}
          </div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <Field label="Email" required>
            <Input
              type="email"
              name="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={busy}
            />
          </Field>

          <Field label="Senha" required>
            <Input
              type="password"
              name="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={busy}
            />
          </Field>

          <div style={{ marginTop: 6 }}>
            <Button
              type="submit"
              variant="primary"
              full
              disabled={busy || !email || !password}
            >
              {busy ? 'Entrando…' : 'Entrar'}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}
